import { makeAutoObservable } from "mobx";

import type { ShapeEscalatedAmount } from "../shapes/ShapeEscalatedAmount.js";
import { FractionHolderDelegate } from "./delegates/FractionHolderDelegate.js";
import { WithNameDelegate } from "./delegates/WithNameDelegate.js";
import { WithUncappedProjectionPeriodsDelegate } from "./delegates/WithUncappedProjectionPeriodsDelegate.js";

export const createEscalatedAmount = (): ShapeEscalatedAmount => ({
  name: "",
  value: null,
  projectionPeriods: [],
});

export class EscalatedAmountFacade {
  constructor(readonly $model: ShapeEscalatedAmount) {
    makeAutoObservable(this);
  }

  get valueHolder() {
    return new FractionHolderDelegate(this.$model);
  }

  get named() {
    return new WithNameDelegate(this.$model);
  }

  get projectionPeriods() {
    return new WithUncappedProjectionPeriodsDelegate(this.$model);
  }
}
